<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <v-form>
      <!-- <mrc_ess_iconGroup
        style="top: -50px"
        :is_disabled="disabled"
        :showEdit="hasBtn('edit-organizaiton-configuration')"
        :show_del="hasBtn('delete-organization-configuration')"
        @handleReturn="handleReturn"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup> -->
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12"
                   sm="12">
              <mrc_ess_multiText :readonly="disabled"
                                 style="width:100%"
                                 :isNational="judegNational('company_desc')"
                                 :label="$t('label_Introduction_to_the') + '*'"
                                 :error-messages="
                  $errors('params', 'company_desc', requiredRule)
                "
                                 v-model="params.company_desc"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="12">
              <mrc_ess_multiText :readonly="disabled"
                                 style="width:100%"
                                 :isNational="judegNational('org_level_short_name')"
                                 :label="$t('label_Organizational_Structure') + '*'"
                                 :error-messages="
                  $errors(
                    'params',
                    'org_level_short_name',
                    requiredRule.concat(maxLength(20))
                  )
                "
                                 v-model="params.org_level_short_name"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_phoneInput label=" "
                                  :readonly="disabled"
                                  :code="params.client_tel_area_code"
                                  :changeCode.sync="params.client_tel_area_code"
                                  v-model="params.company_phone"></mrc_ess_phoneInput>
            </v-col>
            <!-- <v-col
                   cols="12"
                   sm="2">
              <mrc_ess_prompt :disabled='disabled'
                              :rules="false"
                              :label="$t('label_The_area_code')"
                              :chips='false'
                              obj='country_mobile_prefix'
                              v-model="params.client_tel_area_code">
              </mrc_ess_prompt>
            </v-col>
            <v-col
                   cols="12"
                   sm="4">
              <v-text-field :readonly="disabled"
                            :label="$t('label_number')"
                            v-model="params.company_phone"></v-text-field>
            </v-col> -->
            <v-col cols="12"
                   sm="6">
              <mrc_ess_multiText :readonly="disabled"
                                 style="width:100%"
                                 noRequired
                                 :error-messages="$errors('params', 'company_website', urlRule)"
                                 :isNational="judegNational('company_website')"
                                 v-model="params.company_website"
                                 :label="$t('label_The_url')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_multiText :readonly="disabled"
                                 style="width:100%"
                                 noRequired
                                 :error-messages="
                  $errors('params', 'company_industry', maxLength(20))
                "
                                 :isNational="judegNational('company_industry')"
                                 v-model="params.company_industry"
                                 :label="$t('label_industry')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_multiText :readonly="disabled"
                                 style="width:100%"
                                 v-model="params.company_sign_no"
                                 :error-messages="
                  $errors('params', 'company_sign_no', maxLength(20))
                "
                                 :isNational="judegNational('company_sign_no')"
                                 :label="$t('label_Business_Registration_Certificate_Number')"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="6"
                   class="pb-6">
              <!-- :label="$t('label_Company_logo_upload_light') + 'light'" -->
              <mrc_ess_brandupload v-model="params.company_logo_light"
                                   :disabled="disabled"
                                   :label="$t('label_org_m_image_light')"
                                   @deleteicon="deleteicon"
                                   @changeimgSrc="changeimgSrc"></mrc_ess_brandupload>
            </v-col>
            <v-col cols="12"
                   sm="6"
                   class="pb-6">
              <!-- :label="$t('label_Company_logo_upload_light') + 'dark'" -->
              <mrc_ess_brandupload v-model="params.company_logo_dark"
                                   :disabled="disabled"
                                   @deleteicon="deleteicon"
                                   :label="$t('label_org_m_image_dark')"
                                   @changeimgSrc="changeimgSrc2"></mrc_ess_brandupload>
            </v-col>
          </v-row>
          <div class="text--secondary text-h5 d-flex align-center">
            {{ $t("label_address") }}
          </div>
          <v-card-text class="address mt-6">
            <div>
              <v-row>
                <v-col cols="12">
                  <mrc_ess_multiText :readonly="disabled"
                                     noRequired
                                     :label="$t('label_The_street_address')"
                                     :isNational="judegNational('company_address_line_one')"
                                     style="width:100%"
                                     v-model="params.company_address_line_one"></mrc_ess_multiText>
                </v-col>
                <v-col class="mt-n6"
                       cols="12">
                  <mrc_ess_multiText :readonly="disabled"
                                     noRequired
                                     :isNational="judegNational('company_address_line_two')"
                                     style="width:100%"
                                     v-model="params.company_address_line_two"></mrc_ess_multiText>
                </v-col>
                <v-col class="mt-n6"
                       cols="12">
                  <mrc_ess_multiText :readonly="disabled"
                                     noRequired
                                     :isNational="judegNational('company_address_line_three')"
                                     style="width:100%"
                                     v-model="params.company_address_line_three"></mrc_ess_multiText>
                </v-col>
                <!-- <v-col class=""
                       cols="12"
                       sm="4">
                  <mrc_ess_prompt :rules="false"
                                  :disabled='disabled'
                                  :label="$t('label_city')"
                                  :obj='cityObj'
                                  v-model="params.company_address_city_id">
                  </mrc_ess_prompt>
                </v-col> -->

                <v-col cols="12"
                       sm="6">
                  <mrc_ess_prompt :rules="false"
                                  :disabled="disabled"
                                  :label="$t('label_city')"
                                  @getData="params.company_address_city_id = ''"
                                  :obj="provinceObj"
                                  v-model="params.company_address_province_id">
                  </mrc_ess_prompt>
                </v-col>
                <v-col cols="12"
                       sm="6">
                  <mrc_ess_prompt :rules="false"
                                  :disabled="disabled"
                                  :label="$t('label_countries')"
                                  @getData="params.company_address_province_id = ''"
                                  obj="mrbase_common_geo_country"
                                  v-model="params.company_address_country_id">
                  </mrc_ess_prompt>
                </v-col>
                <v-col cols="12">
                  <mrc_ess_multiText v-model="params.company_address_zip_code"
                                     :isNational="judegNational('company_address_zip_code')"
                                     :readonly="disabled"
                                     :label="$t('label_Zip_code')"></mrc_ess_multiText>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card-text>
        <mrc_ess_submitBtn @cancel="cancel"
                           v-if="!disabled"
                           :loading="loading"
                           @success="success"></mrc_ess_submitBtn>
      </v-card>
    </v-form>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators"
import {
  add_update_baseData,
  del_baseData,
  find_baseData,
  get_company_del,
} from "@/service/api/company_set"
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data () {
    return {
      company_logo_light: "",
      company_logo_dark: "",
      loading: false,
      skLoading: true,
      org_level_short_name: "",
      params: {
        uuid: "",
        org_level_uuid: "",
        org_level_short_name: "",
        client_tel_area_code: "",
        company_desc: "",
        company_phone: "",
        company_website: "",
        company_industry: "",
        company_sign_no: "",
        company_logo_dark: "",
        company_address_line_one: "",
        company_address_line_two: "",
        company_address_line_three: "",
        company_address_city_id: null,
        company_address_country_id: null,
        company_address_province_id: null,
        company_address_zip_code: "",
      },
      deleteFileList: [],
    }
  },
  validations: {
    params: {
      company_website: {
        url,
      },
      company_industry: {
        maxLength: maxLength(20),
      },
      company_sign_no: {
        maxLength: maxLength(20),
      },
      company_desc: {
        required,
      },
      org_level_short_name: {
        maxLength: maxLength(20),
        required,
      },
      company_phone: {
        // areaRequired (value) {
        //   if (value) {
        //     return this.params.client_tel_area_code ? true : false
        //   } else {
        //     return true
        //   }
        // },
        // phoneVerify (value) {
        //   if (!value)
        //     return true
        //   const regex = this.$myVerify.phone
        //   return regex.test(this.params.client_tel_area_code + value)
        // }
      },
    },
  },
  created () { },
  async mounted () {
    await this.national("mrbase_sys_company")
    this.params.org_level_uuid = this.$store.state.uuid
    await this.getData()
  },
  methods: {
    deleteicon (v) {
      if (v.uuid) this.deleteFileList.push(v)
    },
    changeimgSrc (v) {
      //将file对象存储待用
      this.company_logo_light = v
    },
    changeimgSrc2 (v) {
      //将file对象存储待用
      this.company_logo_dark = v
    },
    async getData () {
      this.skLoading = true
      const getData = await find_baseData({
        org_level_uuid: this.params.org_level_uuid,
      })
      if (getData.code == 200 && Object.keys(getData.data).length > 0) {
        this.params = getData.data
      }
      this.skLoading = false
    },
    cancel () {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(async () => {
          await this.getData()
          // this.disabled = !this.disabled
          this.$emit("cancel", !this.disabled)
        })
        .catch(() => { })
    },
    async success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      // 上传处理
      let file1 = this.company_logo_light
      let file2 = this.company_logo_dark
      // ---------------------------------分割-----------
      if (!this.params.company_address_city_id) {
        this.params.company_address_city_id = null
      }
      if (!this.params.company_address_country_id) {
        this.params.company_address_country_id = null
      }
      if (!this.params.company_address_province_id) {
        this.params.company_address_province_id = null
      }
      // console.log(this.params.company_desc.length)
      // return
      this.loading = true
      //删除被删除的上传文件
      let deleteFileUuid = []
      this.deleteFileList.forEach((item) => {
        deleteFileUuid.push(item.uuid)
      })
      deleteFileUuid = deleteFileUuid.join()
      let p1 = this.$uploadFiles(file1, {
          module_uuid:'client',
          function_uuid: this.$store.state.menuFunctionUuid,
        attachment_data_table: "mrbase_sys_company",
        attachment_data_field: "company_logo_light",
        org_level_uuid: this.$store.state.uuid,
        uuid: this.$store.state.uuid2, //client_uuid
      })
      let p2 = this.$uploadFiles(file2, {
          module_uuid:'client',
          function_uuid: this.$store.state.menuFunctionUuid,
        attachment_data_table: "mrbase_sys_company",
        attachment_data_field: "company_logo_dark",
        org_level_uuid: this.$store.state.uuid,
        uuid: this.$store.state.uuid2, //client_uuid
      })
      let sasToken = ""
      await Promise.all([p1, p2])
        .then(async (res) => {
          if (
            typeof (res[0] == "object") &&
            res[0] != undefined &&
            res[0].code == 200
          ) {
            this.params.company_logo_light = res[0].uuid
          }
          if (
            typeof (res[1] == "object") &&
            res[1] != undefined &&
            res[1].code == 200
          ) {
            this.params.company_logo_dark = res[1].uuid
          }
          const submit = await add_update_baseData({
            del: deleteFileUuid,
            uuid: this.params.uuid,
            org_level_uuid: this.params.org_level_uuid,
            org_level_short_name: this.params.org_level_short_name,
            company_desc: this.params.company_desc,
            client_tel_area_code: this.params.client_tel_area_code,
            company_phone: this.params.company_phone,
            company_website: this.params.company_website,
            company_industry: this.params.company_industry,
            company_sign_no: this.params.company_sign_no,
            company_logo_light: this.params.company_logo_light,
            company_logo_dark: this.params.company_logo_dark,
            company_address_line_one: this.params.company_address_line_one,
            company_address_line_two: this.params.company_address_line_two,
            company_address_line_three: this.params.company_address_line_three,
            // company_address_city_id: this.params.company_address_city_id,
            company_address_province_id: this.params
              .company_address_province_id,
            company_address_country_id: this.params.company_address_country_id,
            company_address_zip_code: this.params.company_address_zip_code,
          })
          if (submit.code == 200) {
            this.params.uuid = submit.data.uuid
           // this.deleteFileList.forEach((item) => {
           //   this.$deleteFile(item.uuid)
          //  })
            this.deleteFileList = []
            // this.$router.go(-1)
            // this.disabled = true
            this.$emit("changeiconStatus")
            this.$Message({
              text: this.$t("message_The_submission_was_successful"),
            })
          } else {
              this.$deleteFile(rea[0].uuid)
            this.$deleteFile(rea[1].uuid)
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
      this.loading = false
    },
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    // 删除
    handleDel () {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(async () => {
          const del = await get_company_del({
            uuid: this.$store.state.listObj.uuid,
          })
          if (del.code == 200) {
            this.delData(this.$store.state.listObj.uuid)
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            })
            if (
              this.$store.state.userData.userType != 1 &&
              this.$store.state.userData.userType != 4
            ) {
              await this.$store.dispatch("set_topcompanylist")
            }
            this.$router.push({
              name: "enterprise",
            })
          }
        })
        .catch(() => { })
      // this.$myConfirm({ content: '是否删除' })
      //   .then(async () => {
      //     const del = await del_baseData({
      //       org_level_uuid: this.params.org_level_uuid,
      //     })
      //     if (del.code == 200) {
      //       this.$Message({
      //         text: this.$t('message_The_deletion_was_successful'),
      //       })
      //       this.$router.go(-1)
      //     }
      //   })
      //   .catch(() => { })
    },
  },
  computed: {
    provinceObj () {
      return {
        prompt_name: "mrbase_common_geo_province",
        country: this.params.company_address_country_id,
      }
    },
    cityObj () {
      return {
        prompt_name: "mrbase_common_geo_city",
        province: this.params.company_address_province_id,
      }
    },
    verifyPhone () {
      return this.params.client_tel_area_code + this.params.company_phone
    },
  },
  watch: {},
}
</script>

<style scoped>
.address {
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  padding: 20px 20px;
}
</style>
